import { PAGES_LEGALES } from '../pages/chemins-legaux'

/** Liens vers les pages légales (écran de connexion, Compte, Plus, pied des pages légales). Rechargement complet : ces pages sont hors de l'application. */
export function LiensLegaux({ className = '' }: { className?: string }) {
  return (
    <nav aria-label="Informations légales" className={`flex flex-wrap gap-x-4 text-sm ${className}`}>
      {PAGES_LEGALES.map((p) => (
        <a key={p.chemin} href={p.chemin} className="flex items-center underline">
          {p.court}
        </a>
      ))}
    </nav>
  )
}
